@if (visible && plan) {
  <div class="modal-overlay" (click)="close()">
    <div class="modal-panel" (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="modal-header">
        <div class="modal-header-content">
          <div class="plan-icon-lg">
            <i class="pi pi-box"></i>
          </div>
          <div>
            <h3 class="modal-title">{{ plan.name }}</h3>
            <p class="modal-subtitle">Subscription Plan Details</p>
          </div>
        </div>
        <button class="close-btn" (click)="close()">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">

        <!-- Status + Plan Type Row -->
        <div class="badges-row">
          <span class="plan-badge" [class.status-active]="plan.isActive" [class.status-expired]="!plan.isActive">
            {{ plan.isActive ? 'Active' : 'Inactive' }}
          </span>
          <span class="type-badge">
            {{ plan.subscriptionType | titlecase }}
          </span>
          <span class="platform-badge">
            {{ plan.platform | titlecase }}
          </span>
        </div>

        <!-- Info Grid -->
        <div class="info-grid">
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-dollar"></i></div>
            <div>
              <p class="info-label">Price</p>
              <p class="info-value">{{ plan.price | currency: plan.currency || 'USD' }}</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-clock"></i></div>
            <div>
              <p class="info-label">Duration</p>
              <p class="info-value">{{ plan.duration }} Days</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-apple"></i></div>
            <div>
              <p class="info-label">APP STORE PRODUCT ID</p>
              <p class="info-value" style="word-break: break-all;">{{ plan.appStoreProductId || 'N/A' }}</p>
            </div>
          </div>
          <div class="info-card">
            <div class="info-icon"><i class="pi pi-android"></i></div>
            <div>
              <p class="info-label">PLAY STORE PRODUCT ID</p>
              <p class="info-value" style="word-break: break-all;">{{ plan.playStoreProductId || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <!-- Limits Section -->
        @if (plan.limits) {
          <div class="limits-section">
            <h4 class="section-title"><i class="pi pi-sliders-h"></i> Daily Limits</h4>
            <div class="limits-grid">
              <div class="limit-item">
                <span class="limit-label">Daily Swipes:</span>
                @if (isEditing) {
                  <input type="number" class="limit-input" [(ngModel)]="editLimits.dailySwipes" min="0" />
                } @else {
                  <span class="limit-value">{{ plan.limits.dailySwipes }}</span>
                }
              </div>
              <div class="limit-item">
                <span class="limit-label">Daily Pops:</span>
                @if (isEditing) {
                  <input type="number" class="limit-input" [(ngModel)]="editLimits.dailyPops" min="0" />
                } @else {
                  <span class="limit-value">{{ plan.limits.dailyPops }}</span>
                }
              </div>
              <div class="limit-item">
                <span class="limit-label">Daily Super Likes:</span>
                @if (isEditing) {
                  <input type="number" class="limit-input" [(ngModel)]="editLimits.dailySuperLikes" min="0" />
                } @else {
                  <span class="limit-value">{{ plan.limits.dailySuperLikes }}</span>
                }
              </div>
              <div class="limit-item">
                <span class="limit-label">Daily Rewinds:</span>
                @if (isEditing) {
                  <input type="number" class="limit-input" [(ngModel)]="editLimits.dailyRewinds" min="0" />
                } @else {
                  <span class="limit-value">{{ plan.limits.dailyRewinds }}</span>
                }
              </div>
            </div>
          </div>
        }

        <!-- Features -->
        @if (plan.features && plan.features.length > 0) {
          <div class="features-section">
            <h4 class="section-title">
              <i class="pi pi-check-circle"></i> Plan Features
            </h4>
            <ul class="features-list">
              @for (feature of plan.features; track feature) {
                <li class="feature-item">
                  <i class="pi pi-check feature-check"></i>
                  {{ feature }}
                </li>
              }
            </ul>
          </div>
        }

        <!-- Description -->
        @if (plan.description) {
          <div class="description-section">
            <h4 class="section-title"><i class="pi pi-info-circle"></i> Description</h4>
            <p class="description-text">{{ plan.description }}</p>
          </div>
        }

        <!-- Plan ID -->
        <div class="sub-id-row">
          <span class="sub-id-label">Plan Product ID</span>
          <code class="sub-id">{{ plan.productId }}</code>
        </div>

      </div>

      <!-- Footer -->
      <div class="modal-footer" style="display: flex; justify-content: flex-end; gap: 8px; padding: 1rem 1.5rem; border-top: 1px solid #f3f4f6;">
        @if (isEditing) {
          <button class="btn btn-outline" style="padding: 6px 16px; border: 1px solid #d1d5db; border-radius: 6px;" (click)="cancelEdit()">Cancel</button>
          <button class="create-lobby-btn" style="padding: 6px 16px; border-radius: 6px; width: auto;" [disabled]="isSaving" (click)="saveEdit()">
            @if (isSaving) { <i class="pi pi-spin pi-spinner"></i> } @else { Save }
          </button>
        } @else {
          <button class="btn btn-outline" style="padding: 6px 16px; border: 1px solid #d1d5db; border-radius: 6px;" (click)="startEdit()">Edit Limits</button>
          <button class="btn-close-footer" (click)="close()">Close</button>
        }
      </div>

    </div>
  </div>
}
